import { AlignType } from 'common/types/styleTypes'
import { useFontSize } from './use-font-size'
import { useLineHeight } from './use-line-height'
import { useTextAlign } from './use-text-align'
import { useLetterSpacing } from './use-letter-spacing'
import { useFontFamily } from './use-font-family'
import { useFontStyle } from './use-font-style'
import { useFontWeight } from './use-font-weight'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'

export const useTypography = ({
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
  textAlign,
  mobileTextAlign,
  letterSpacing,
  mobileLetterSpacing,
  fontFamily,
  mobileFontFamily,
  fontStyle,
  mobileFontStyle,
  fontWeight,
  mobileFontWeight,
  typographyType,
}: {
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  letterSpacing?: number
  mobileLetterSpacing?: number
  fontFamily?: string
  mobileFontFamily?: string
  fontStyle?: string
  mobileFontStyle?: string
  fontWeight?: string
  mobileFontWeight?: string
  typographyType?: WebsiteSettingsTypographyTypeEnum
} = {}) => {
  const returnUseFontFamily = useFontFamily({
    fontFamily,
    mobileFontFamily,
    typographyType,
  })

  const returnUseFontStyle = useFontStyle({
    fontStyle,
    mobileFontStyle,
    typographyType,
  })

  const returnUseFontWeight = useFontWeight({
    fontWeight,
    mobileFontWeight,
    typographyType,
  })

  const returnUseFontSize = useFontSize({
    fontSize,
    mobileFontSize,
    typographyType,
  })

  const returnUseLineHeight = useLineHeight({
    fontSize,
    mobileFontSize,
    lineHeight,
    mobileLineHeight,
    typographyType,
  })

  const returnUseTextAlign = useTextAlign({
    textAlign,
    mobileTextAlign,
    typographyType,
  })

  const returnUseLetterSpacing = useLetterSpacing({
    letterSpacing,
    mobileLetterSpacing,
    typographyType,
  })

  return {
    ...returnUseFontSize,
    ...returnUseLineHeight,
    ...returnUseTextAlign,
    ...returnUseLetterSpacing,
    ...returnUseFontFamily,
    ...returnUseFontWeight,
    ...returnUseFontStyle,
  }
}
